module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightsnowshowers-fc2c68688a03a5ededef4beb12a96439.webp";